export default "__VITE_ASSET__2d87aade__"